(function () {
    function ensureOverlay() {
        var overlay = document.getElementById('dtcLoadingOverlay');
        if (overlay) {
            return overlay;
        }

        overlay = document.createElement('div');
        overlay.id = 'dtcLoadingOverlay';
        overlay.className = 'dtc-loading-overlay';
        overlay.hidden = true;
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-live', 'polite');
        overlay.innerHTML =
            '<div class="dtc-loading-overlay__panel" role="status">' +
                '<div class="dtc-loading-overlay__spinner" aria-hidden="true"></div>' +
                '<p class="dtc-loading-overlay__message mb-0">Processing…</p>' +
            '</div>';
        document.body.appendChild(overlay);

        return overlay;
    }

    var overlay = ensureOverlay();
    var messageEl = overlay.querySelector('.dtc-loading-overlay__message');

    function showLoading(message) {
        if (messageEl) {
            messageEl.textContent = message || 'Processing…';
        }
        overlay.hidden = false;
        overlay.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-busy', 'true');
        document.body.classList.add('dtc-loading-active');
    }

    function hideLoading() {
        overlay.hidden = true;
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-busy', 'false');
        document.body.classList.remove('dtc-loading-active');
        document.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
            button.disabled = false;
        });
    }

    window.dtcShowLoading = showLoading;
    window.dtcHideLoading = hideLoading;

    function enableDisabledFieldsForValidation(form) {
        // Disabled fields are skipped by HTML5 validation and omitted from submit.
        // Only re-enable selects that already have a value (e.g. cascade still locked).
        // Enabling empty placeholder selects would POST blank values and wipe prefill
        // via old() after a failed save.
        var restored = [];
        form.querySelectorAll('select[disabled]').forEach(function (select) {
            if (!select.value) {
                return;
            }
            select.disabled = false;
            restored.push(select);
        });
        return restored;
    }

    document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) {
            return;
        }
        if (form.dataset.dtcNoLoading !== undefined) {
            return;
        }

        var confirmMessage = form.getAttribute('data-confirm');
        if (confirmMessage && !window.confirm(confirmMessage)) {
            event.preventDefault();
            hideLoading();
            return;
        }

        var reenabledSelects = enableDisabledFieldsForValidation(form);

        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            event.preventDefault();
            reenabledSelects.forEach(function (select) {
                select.disabled = true;
            });
            hideLoading();
            if (typeof form.reportValidity === 'function') {
                form.reportValidity();
            }
            return;
        }

        showLoading(form.dataset.loadingMessage || 'Processing…');

        form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
            button.disabled = true;
        });
    });

    document.querySelectorAll('[data-dtc-loading]').forEach(function (element) {
        element.addEventListener('click', function () {
            showLoading(element.getAttribute('data-dtc-loading') || 'Loading…');
        });
    });

    window.addEventListener('pageshow', function () {
        hideLoading();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            hideLoading();
        }
    });

    // Clear any stuck overlay from a prior submit (e.g. back/forward or failed navigation).
    hideLoading();

    function formatMoney(amount, decimals) {
        var value = Number(amount);
        if (!isFinite(value)) {
            value = 0;
        }
        return value.toLocaleString('en-US', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    }

    function minimumDownPayment(totalCost) {
        var rateDown = Math.round(totalCost * 0.051 * 100) / 100;
        var capDown = Math.round(Math.max(0, totalCost - 10000) * 100) / 100;
        return Math.max(rateDown, capDown);
    }

    function totalFinanceCost(totalCost, downPayment, feePercent) {
        if (feePercent >= 1) {
            return Math.round(totalCost * 100) / 100;
        }
        var financedPrincipal = totalCost - downPayment;
        if (financedPrincipal <= 0) {
            return Math.round(totalCost * 100) / 100;
        }
        return Math.round(((financedPrincipal / (1 - feePercent)) + downPayment) * 100) / 100;
    }

    function addonTotalFromRoot(root) {
        var total = 0;
        root.querySelectorAll('[data-dtc-addon]').forEach(function (input) {
            if (input.checked) {
                total += parseInt(input.getAttribute('data-price') || '0', 10) || 0;
            }
        });
        return total;
    }

    function selectedAddonsPayload(root) {
        var payload = {};
        root.querySelectorAll('[data-dtc-addon]').forEach(function (input) {
            var field = input.getAttribute('data-field');
            if (field) {
                payload[field] = input.checked ? 1 : 0;
            }
        });
        return payload;
    }

    function csrfToken() {
        var meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.getAttribute('content') : '';
    }

    function persistAddons(root) {
        var url = root.getAttribute('data-addons-url');
        if (!url) {
            return;
        }

        var body = new URLSearchParams();
        var selected = selectedAddonsPayload(root);
        Object.keys(selected).forEach(function (field) {
            if (selected[field]) {
                body.append(field, '1');
            }
        });

        fetch(url, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken(),
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            credentials: 'same-origin',
            body: body.toString(),
        }).catch(function () {
            // Pricing still updates client-side; session sync is best-effort.
        });
    }

    function refreshPlanRowPrices(root) {
        var addonCost = addonTotalFromRoot(root);
        root.querySelectorAll('[data-dtc-plan-row]').forEach(function (row) {
            var baseTotal = parseFloat(row.getAttribute('data-base-total') || '0') || 0;
            var financeMonths = parseInt(row.getAttribute('data-finance-months') || '0', 10) || 0;
            var feePercent = parseFloat(row.getAttribute('data-fee-percent') || '0') || 0;
            var totalCost = baseTotal + addonCost;
            var pifCell = row.querySelector('[data-dtc-plan-pif]');
            var financeCell = row.querySelector('[data-dtc-plan-finance]');

            if (pifCell) {
                pifCell.textContent = '$' + formatMoney(totalCost, 0);
            }

            if (!financeCell) {
                return;
            }

            if (financeMonths <= 0) {
                financeCell.textContent = '—';
                return;
            }

            var downPayment = minimumDownPayment(totalCost);
            var financedTotal = totalFinanceCost(totalCost, downPayment, feePercent);
            var monthly = Math.round(((financedTotal - downPayment) / Math.max(1, financeMonths)) * 100) / 100;

            financeCell.textContent =
                '$' + formatMoney(downPayment, 0) + ' down · $' +
                formatMoney(monthly, 2) + '/mo · ' +
                financeMonths + ' mo · $' +
                formatMoney(financedTotal, 2) + ' financed';
        });
    }

    function initPlansAddonPricing() {
        var root = document.querySelector('[data-dtc-plans-pricing]');
        if (!root) {
            return;
        }

        root.querySelectorAll('[data-dtc-addon]').forEach(function (input) {
            input.addEventListener('change', function () {
                refreshPlanRowPrices(root);
                persistAddons(root);
            });
        });
    }

    function initSidebar() {
        var toggleBtn = document.getElementById('dealerPortalSidebarToggle');
        var closeBtn = document.getElementById('dealerPortalSidebarClose');
        var backdrop = document.getElementById('dealerPortalSidebarBackdrop');
        if (!toggleBtn && !closeBtn && !backdrop) {
            return;
        }

        function setOpen(open) {
            document.body.classList.toggle('dealer-portal-sidebar--open', open);
            if (backdrop) {
                backdrop.hidden = !open;
                backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
            }
            if (toggleBtn) {
                toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
            }
            document.body.style.overflow = open ? 'hidden' : '';
        }

        function close() {
            setOpen(false);
        }

        if (toggleBtn) {
            toggleBtn.addEventListener('click', function () {
                setOpen(!document.body.classList.contains('dealer-portal-sidebar--open'));
            });
        }
        if (closeBtn) {
            closeBtn.addEventListener('click', close);
        }
        if (backdrop) {
            backdrop.addEventListener('click', close);
        }
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') close();
        });
        window.addEventListener('resize', function () {
            if (window.matchMedia('(min-width: 992px)').matches) close();
        });
        document.querySelectorAll('.dealer-portal-sidebar__link').forEach(function (a) {
            a.addEventListener('click', function () {
                if (window.matchMedia('(max-width: 991.98px)').matches) close();
            });
        });
    }

    function init() {
        initPlansAddonPricing();
        initSidebar();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
